//scripts
import './scripts/animations';
// import './scripts/letterize'; //require package
import './scripts/sliders';
import './scripts/theme';

//styles
import './style.scss';